import {
  AddConsultantEventLogCallMutationVariables,
  GetPersonalInfoCardData,
  useAddConsultantEventLogCallMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useAddConsultantEventLogCall(props: HookProps) {
  const [addConsultantEventLogCallMutation] = useAddConsultantEventLogCallMutation({
    onError: (error) => {
      console.error(error);
      props.onError && props.onError(error);
    },
    onCompleted: (res) => {
      props.onCompleted && props.onCompleted(res.addConsultantCallEvent);
    }
  });

  const addConsultantEventLogCall = (
    args: AddConsultantEventLogCallMutationVariables
  ) => {
    props.onBeforeCall && props.onBeforeCall();
    addConsultantEventLogCallMutation({
      variables: args,
      refetchQueries: [GetPersonalInfoCardData.OperationName]
    });
  };

  return { addConsultantEventLogCall };
}
